export type ItemKeySelector<T> = (item: T) => string;

export type UniqueByKeyOptions = {
  normalizeKey?: (key: string) => string;
  skipEmptyKeys?: boolean;
};

const defaultNormalizeKey = (key: string) => key.trim().toLowerCase();

/**
 * Returns items with at most one entry per normalized key (first occurrence wins).
 */
export const uniqueByKey = <T>(
  items: T[],
  getKey: ItemKeySelector<T>,
  options?: UniqueByKeyOptions
): T[] => {
  const normalize = options?.normalizeKey ?? defaultNormalizeKey;
  const skipEmpty = options?.skipEmptyKeys ?? true;
  const seen = new Set<string>();
  const result: T[] = [];

  for (const item of items) {
    const key = normalize(getKey(item));
    if (skipEmpty && !key) {
      continue;
    }
    if (seen.has(key)) {
      continue;
    }
    seen.add(key);
    result.push(item);
  }

  return result;
};
